const data = {
	"body": "<path fill=\"currentColor\" d=\"M5.56 14L5 13.587V2.393L5.54 2L11 7.627v.827L5.56 14z\"/>"
};
exports.__esModule = true;
exports.default = data;
